import { FC } from 'react';
import { Box } from '@mui/material';

export const BonusProgram: FC = () => {
    return (
        <Box>
            Тест редиректа
        </Box>
            
    );
};

export default BonusProgram;
